import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Details from '../Components/Details'
import ExerciseVideo from '../Components/ExerciseVideo'
import SimilarVideo from '../Components/SimilarVideo'
import data from "../utils/datasss.json"
import { fetchDatas, youtubeOptions } from '../utils/fetchData'

const ExerciseDetail = () => {
  const [exerciseData, setExerciseData] = useState([])
  const [exerciseVideos, setExerciseVideos] = useState([])
  const [muscle, setMuscle] = useState([])

  const id = useParams()
  // console.log(data.data[0]);
  useEffect(() => {

    const Apidata = data.data.filter((e) => e.id === id.id)
    // console.log(Apidata[0].name)
    setExerciseData(Apidata[0])

    const fetchApiDatas = async () => {
      const youtubeSearchUrl = "https://youtube-search-and-download.p.rapidapi.com"
      console.log(youtubeSearchUrl);
      const exerciseVideoData = await fetchDatas(`${youtubeSearchUrl}/search?query=${Apidata[0].name} exercise`, youtubeOptions);
      setExerciseVideos(exerciseVideoData)
    }
    fetchApiDatas()

    const MuscleData = Apidata[0]
    //  console.log(MuscleData.target);
    setMuscle(MuscleData.target)
  }, [id])
  return (
    <div>
      <Box>
        <Details exerciseData={exerciseData} />
        <ExerciseVideo exerciseVideos={exerciseVideos} name={exerciseData.name} />
        {/* <SimilarVideo muscle={muscle} />  */}
      </Box>
    </div>
  )
}

export default ExerciseDetail
